export default __webpack_public_path__ + "static/media/Blog-cards-img.700e78f7.jpg";